"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingSummaryUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var date_1 = require("../../../../../shared/core/utils/date");
var analytics_subjects_1 = require("../../../analytics-subjects");
var StyledContentGrid_styled_1 = require("../../../components/StyledContentGrid.styled");
var copy_1 = require("../../../copy");
var BillingPeriodCard_1 = require("./components/BillingPeriodCard");
var getPeriodState = function (period) {
    return (0, date_1.isValidToday)(period.startDate, period.endDate)
        ? 'current'
        : period.isStatementAvailable
            ? 'ended'
            : 'pending';
};
var SummaryPeriods = function (_a) {
    var periods = _a.periods, totalCompletedPeriods = _a.totalCompletedPeriods;
    var ContentGrid = (0, core_1.useComponents)().ContentGrid;
    var periodId = totalCompletedPeriods - 1;
    var billingPeriods = periods.map(function (period, index) {
        return !period ? (react_1.default.createElement(BillingPeriodCard_1.BillingPeriodCard, { key: index, displayStatus: 'empty', position: index + 1 })) : (react_1.default.createElement(BillingPeriodCard_1.BillingPeriodCard, { key: index, startDate: period.startDate, endDate: period.endDate, charge: period.totalCharges.gross.value, periodId: period.id || !(0, date_1.isValidToday)(period.startDate, period.endDate)
                ? "".concat(periodId--)
                : '', displayStatus: getPeriodState(period), position: index + 1 }));
    });
    return (react_1.default.createElement(StyledContentGrid_styled_1.StyledContentGrid, { as: ContentGrid, size: "30rem" },
        react_1.default.createElement(StyledContentGrid_styled_1.StyledContentGrid, { as: ContentGrid, size: "14rem" },
            billingPeriods[0],
            billingPeriods[1]),
        react_1.default.createElement(StyledContentGrid_styled_1.StyledContentGrid, { as: ContentGrid, size: "14rem" },
            billingPeriods[2],
            billingPeriods[3])));
};
var Footer = function () {
    var _a, _b;
    var _c = (0, core_1.useLinks)(), billingHistory = _c.billingHistory, howBillingWorks = _c.howBillingWorks;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _d = (0, core_1.useComponents)(), PrimaryCTALink = _d.PrimaryCTALink, ButtonGroup = _d.ButtonGroup, P = _d.P, TextLink = _d.TextLink, InternalLink = _d.InternalLink;
    return (react_1.default.createElement(ButtonGroup, null,
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_SUMMARY_HISTORY_CTA, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
            react_1.default.createElement(PrimaryCTALink, { as: InternalLink, href: billingHistory(), "data-testid": "billing-summary-view-history-link" },
                react_1.default.createElement(Copy, { copyKey: "viewFullHistory" }))),
        react_1.default.createElement(P, null,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_SUMMARY_HELP_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                react_1.default.createElement(TextLink, { href: howBillingWorks(), "data-testid": "billing-summary-help-link" },
                    react_1.default.createElement(Copy, { copyKey: "understandBillingLink" }))))));
};
var BillingSummaryUI = function (_a) {
    var summaryPeriods = _a.summaryPeriods, totalCompletedPeriods = _a.totalCompletedPeriods;
    var SummaryCard = (0, core_1.useComponents)().SummaryCard;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(SummaryCard, { "data-testid": "billing-data", heading: react_1.default.createElement(Copy, { copyKey: "billingSummaryTitle" }), icon: "billing", footer: react_1.default.createElement(Footer, null) },
        react_1.default.createElement(SummaryPeriods, { periods: summaryPeriods, totalCompletedPeriods: totalCompletedPeriods })));
};
exports.BillingSummaryUI = BillingSummaryUI;
